import { render } from "./formModal.vue?vue&type=template&id=13ced34e&scoped=true"
import script from "./formModal.vue?vue&type=script&lang=js"
export * from "./formModal.vue?vue&type=script&lang=js"

import "./formModal.vue?vue&type=style&index=0&id=13ced34e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ced34e"]])

export default __exports__